
import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { WifiOff } from "lucide-react";

interface NetworkErrorAlertProps {
  isVisible: boolean;
}

const NetworkErrorAlert: React.FC<NetworkErrorAlertProps> = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <Alert variant="destructive" className="mb-4">
      <WifiOff className="h-4 w-4" />
      <AlertTitle>Connection issue</AlertTitle>
      <AlertDescription>
        You appear to be offline. Please check your internet connection.
      </AlertDescription>
    </Alert>
  );
};

export default NetworkErrorAlert;
